import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["paymentMethodId", "id", "className", "children", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/PaymentSelect.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function PaymentRadioButton(_ref, ref) {
  var paymentMethodId = _ref.paymentMethodId,
      id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.paymentInput, _defineProperty({}, styles.disabled, disabled)),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        type: "radio",
        name: "paymentMethod",
        id: id,
        disabled: disabled
      }, props)), /*#__PURE__*/_jsxs("label", {
        htmlFor: id,
        className: className,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.check
        }), children]
      })]
    })
  });
}

export default /*#__PURE__*/forwardRef(PaymentRadioButton);